import statuses from '@/store/statuses';
import Services from '@/services/index';
import VT from '@/store/types';

const TranslationsService = Services.translations;

export default {
  [VT.TRANSLATIONS_LIST]: ({ commit, state }, params) => {
    state.translationsList['status'] = statuses.LOADING;
    TranslationsService.list(params).then((data) => {
      commit(VT.TRANSLATIONS_LIST, data);
    }).catch((errResponse) => {
      commit(VT.TRANSLATIONS_LIST, errResponse);
    });
  },
  [VT.UNTRANSLATED]: () => {
    return new Promise((resolve, reject) => {
      TranslationsService.untranslated().then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.TRANSLATION_CREATE_DATA]: () => {
    return new Promise((resolve, reject) => {
      TranslationsService.createData().then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.TRANSLATION_UPDATE_DATA]: ({}, id) => {
    return new Promise((resolve, reject) => {
      TranslationsService.editData(id).then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.TRANSLATION_CREATE]: ({}, createData) => {
    return new Promise((resolve, reject) => {
      TranslationsService.create(createData).then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.TRANSLATION_UPDATE]: ({}, updateData) => {
    return new Promise((resolve, reject) => {
      TranslationsService.update(updateData).then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
  [VT.TRANSLATION_DELETE]: ({}, id) => {
    return new Promise((resolve, reject) => {
      TranslationsService.delete(id).then((data) => {
        resolve(data);
      }).catch((data) => {
        reject(data);
      });
    });
  },
};
